import React, { useEffect } from "react";

import { HACKLE_UNASSIGNED_VARIATION } from "../../constants/hackle";
import { useCustomVariation } from "../../hooks/useCustomVariation";

interface ABEnabledContainerProps {
  experimentKey: number;
  ComponentA: React.ReactElement;
  ComponentB: React.ReactElement;
  /**
   * variation이 "A" 또는 "B"로 확정된 시점에 호출.
   * "Z"(로딩/미할당) 상태에서는 호출되지 않음.
   * 실험 모수 마킹 등 정확한 노출 시점에 부수효과를 걸 때 사용.
   */
  onAssigned?: (variation: "A" | "B") => void;
}

/**
 * A/B 콘텐츠 스왑용 선언형 컨테이너. platform goi_common ABEnabledContainer와 동일 역할.
 *
 * 확정 전("Z")에는 아무것도 렌더하지 않는다. 즉 A·B가 서로 다른 콘텐츠일 때 확정 전 A를
 * 보여주다 B로 갈아치우는 flash를 막는 게 목적이다.
 *
 * 언제 쓰나: A와 B가 각각 실제 콘텐츠인 스왑 실험.
 * 언제 안 쓰나: 한쪽에만 요소를 더하는 additive 실험. 그 경우 ComponentA={<></>}가 되어
 * 보일러플레이트만 늘어난다. 컴포넌트 안에서 useCustomVariation을 직접 호출하고
 * 원하는 변이가 아니면 null을 반환하는 편이 짧다(ParlorQuickInquiry가 그 방식).
 */
export const ABEnabledContainer = ({
  experimentKey,
  ComponentA,
  ComponentB,
  onAssigned,
}: ABEnabledContainerProps) => {
  const variation = useCustomVariation(experimentKey);
  const loading = variation === HACKLE_UNASSIGNED_VARIATION;

  useEffect(() => {
    if (variation === "A" || variation === "B") {
      onAssigned?.(variation);
    }
  }, [variation, onAssigned]);

  if (loading) return null;

  return variation === "A" ? ComponentA : ComponentB;
};
